import { combineReducers } from 'redux';

import login from './login';
import day from './day';
import chart from './chart';
import mainMetrico from './mainMetrico';
import reports from './reports';
import evaluacionOptima from './evaluacionOptima';
import mainDashboard from './mainDashboard';
import dealerProfile from './dealerProfile';
import main from './main';
import resumenGerencial from './resumenGerencial';
import saveForm from './saveForm';
import evaluacionGarantias from './evaluacionGarantias';
import testChart from './test_chart';
import dashboardServicios from './dashboardServicios';
import inventarioRDSMxl from './inventarioRDSMxl';
import evaluacionDesempeño from './evaluacionDesempeño';

export default combineReducers({
  main,
  login,
  day,
  chart,
  mainMetrico,
  reports,
  evaluacionOptima,
  mainDashboard,
  dealerProfile,
  resumenGerencial,
  saveForm,
  evaluacionGarantias,
  testChart,
  dashboardServicios,
  inventarioRDSMxl,
  evaluacionDesempeño,
});
